import axios from 'axios'
import { getFirebaseIdToken } from './token'

const BASE_URL = process.env.VUE_APP_KPD_API_URL || 'https://europe-west1-ai-fisk-prod.cloudfunctions.net/kpdSifre'

const kpdClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Auto-inject Bearer token
kpdClient.interceptors.request.use(async (config) => {
  try {
    const token = await getFirebaseIdToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  } catch (error) {
    console.error('Error getting token for KPD Šifre API:', error)
  }
  return config
})

// Error handling
kpdClient.interceptors.response.use(
  (response) => response,
  (error) => {
    let errorMessage = error.message || 'Network error occurred'

    if (error.response?.data) {
      const responseData = error.response.data
      errorMessage = responseData.error || responseData.details || responseData.message || errorMessage
    }

    console.error('KPD Šifre API Error:', errorMessage)
    error.parsedMessage = errorMessage

    return Promise.reject(error)
  }
)

function buildQueryParams (params) {
  const searchParams = new URLSearchParams()

  Object.keys(params).forEach(key => {
    if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
      if (Array.isArray(params[key])) {
        // Handle arrays (like categories)
        params[key].forEach(value => {
          searchParams.append(`${key}[]`, value)
        })
      } else {
        searchParams.append(key, params[key])
      }
    }
  })

  return searchParams.toString()
}

export const kpdSifraApi = {
  async fetchItems (filters = {}) {
    const params = {
      company_id: filters.companyId,
      location_id: filters.locationId,
      limit: filters.limit || 20
    }

    if (filters.startAfter) {
      params.start_after = filters.startAfter
    }

    if (filters.searchTerm) {
      params.search_term = filters.searchTerm
    }

    if (filters.searchKpd) {
      params.search_kpd = filters.searchKpd
    }

    if (filters.hasKpdCode !== null && filters.hasKpdCode !== undefined) {
      params.has_kpd = filters.hasKpdCode
    }

    if (filters.categories && Array.isArray(filters.categories) && filters.categories.length > 0) {
      params.categories = filters.categories
    }

    const queryString = buildQueryParams(params)
    const response = await kpdClient.get(`/?${queryString}`)
    return response.data
  },

  async updateKpdCode (companyId, locationId, itemId, kpdcode) {
    const payload = {
      company_id: companyId,
      location_id: locationId,
      item_id: itemId,
      kpdcode: kpdcode || ''
    }
    const response = await kpdClient.patch('/', payload)
    return response.data
  },

  async bulkUpdateKpdCodes (companyId, locationId, itemIds, kpdcode) {
    const payload = {
      company_id: companyId,
      location_id: locationId,
      item_ids: itemIds,
      kpdcode: kpdcode || ''
    }
    const response = await kpdClient.post('/bulk-update', payload)
    return response.data
  },

  async bulkUpdateByCategory (companyId, locationId, categoryId, kpdcode) {
    const payload = {
      company_id: companyId,
      location_id: locationId,
      category_id: categoryId,
      kpdcode: kpdcode || ''
    }
    const response = await kpdClient.post('/bulk-update-category', payload)
    return response.data
  }
}

export default kpdSifraApi
